<div class="page_title">
    <div class="row marges">
        <div class="col y_items_center">
            <h1 class="title">{{ 'sca.title.value' | translate }}</h1>
        </div>

    </div>
</div>

<div *ngIf="params.controlStatus === 'VALIDATED'">

    <div class="row marges ligne_form">
        <div class="col_12">
            <div class="form_paymment_reponse">
                <p class="title success">{{ 'sca.validation.success.title.value' | translate }}</p>
            </div>
        </div>
    </div>

    <div class="row marges ligne_form">
        <div class="col_12">
            <div class="form_paymment_reponse">
                <p>{{ 'sca.validation.success.description.value' | translate }}</p>
            </div>
        </div>
    </div>

    <div class="row marges ligne_form">
        <div class="col_12">
            <div class="form_paymment_reponse">
                <p><strong>{{ 'subscription.success.thanks.value' | translate }}</strong></p>
            </div>
        </div>
    </div>

    @switch (params.origin){

        @case (SocietyValidationAccountOrigin.RecipientUpdate){

            <br>

            <div class="row marges">
                <div class="col_content">
                    <button class="btn_cta btn_little" (click)="redirectToDocuments()">{{ 'document.own.plural.mangopay.back.action.value' | translate }}</button>
                </div>
            </div>
        }
    }

</div>

<div *ngIf="params.controlStatus === 'FAILED'">

    <div class="row marges ligne_form">
        <div class="col_12">
            <div class="form_paymment_reponse">
                <p class="title error">{{ 'sca.validation.error.title.value' | translate }}</p>
            </div>
        </div>
    </div>

    @if(societyValidationAccount.redirectUrl){

        <br>

        <div class="ck-content">
            <p [innerHTML]="'sca.activation.description.value' | translate"></p>
        </div>

        <br>

        <div class="ck-content">
            <p [innerHTML]="'sca.activation.help.value' | translate"></p>
        </div>

        <br>

        <div class="row marges">
            <div class="col_content">
                <button class="btn_cta btn_little btn_green_lines" (click)="redirectToSca()">{{ 'sca.activation.action.value' | translate }}</button>
            </div>
        </div>

    } @else {

        <br>

        <div class="ck-content">
            <p [innerHTML]="'sca.validation.error.description.value' | translate"></p>
        </div>
    }

</div>

